import * as React from 'react'
import Helmet from 'react-helmet'

import { Site } from '../../../../common/constants/siteList'
import getRSSFeeds from '../../../../common/utils/getRSSFeeds'
import siteConfigs from '../../../../config/sites'
import siteConfigMenus from '../../../../config/sites/menus'

interface IProps {
  seoMeta: any
  location: any
  currentSite: Site
  noIndex: boolean
  baseUrl: string
  canonicalPath: string
}

export default ({
  seoMeta,
  location,
  currentSite,
  noIndex,
  baseUrl,
  canonicalPath
}: IProps) => {
  const title = seoMeta.title || ''
  const description = seoMeta.meta_description || seoMeta.description || ''
  const siteConfig = siteConfigs[currentSite]

  // Defining meta tags
  const meta = [
    { name: 'description', content: description },
    { property: 'og:title', content: title },
    { property: 'og:description', content: description }
  ]

  // set no index header
  if (noIndex) {
    meta.push({ name: 'robots', content: 'noindex' })
  }

  meta.push({ property: 'og:url', content: baseUrl + canonicalPath })
  // Defining link tags
  const link: Array<React.AnchorHTMLAttributes<HTMLAnchorElement>> = [
    { rel: 'canonical', href: baseUrl + canonicalPath }
  ]

  // Define extra scripts
  const script = [
    {
      type: 'application/ld+json',
      innerHTML: `{
        "@context": "http://schema.org",
        "@type": "WebSite",
        "name": "${siteConfig.name}",
        "url": "${baseUrl}"
      }`
    }
  ]

  // rss feeds links
  const menuConfig = siteConfigMenus[currentSite]
  const RSSFeeds = getRSSFeeds(
    currentSite,
    menuConfig,
    siteConfig.feeds_categories || []
  )
  if (RSSFeeds.length) {
    RSSFeeds.forEach(feed => {
      link.push({
        rel: 'alternate',
        type: 'application/atom+xml',
        href: feed.url,
        title: feed.title
      })
    })
  }

  return (
    <Helmet
      title={title}
      defaultTitle="Envato Market"
      meta={meta}
      link={link}
      script={script}
    />
  )
}
